import React, { createContext, useState, useContext, useEffect } from "react";

// Δημιουργία Context
const LanguageContext = createContext();

// Διαθέσιμα κείμενα ανά γλώσσα
const translations = {
  en: {
    title: "ART OF BETTING",
    slogan: "The Art of Strategic Betting",
    home: "Home",
    aboutUs: "About Us",
    freeBets: "FREE BETS",
    freeBetsDesc: "Check our free predictions",
    freeBetsToday: "Free Bets",
    pregame: "Pregame",
    live: "Live",
    vip: "VIP",
    vipDesc: "Join the winning team",
    vipBetsToday: "VIP Bets",
    statistics: "STATISTICS",
    statisticsDesc: "Check our tipsters numbers",
    statisticsToday: "Statistics",
    articles: "ARTICLES",
    articlesDesc: "Read our tipsters' articles",
    articlesToday: "Articles",
    algorithm: "ALGORITHM",
    algorithmDesc: "Predictions from our smart algorithm",
    poker: "POKER",
    pokerDesc: "Poker Tactics That Will Make You a Champion",
    learnMore: "Enter and win!",
    learnMoreStats: "Check what the numbers say!",
    learnMoreArticles: "Study them!",
    inprogress: "In progress",
    switchTo: "Ελληνικά",
    login: "Login",
    logout: "Logout",
    register: "Register",
    username: "Username",
    usernameOrEmail: "Username or Email",
    password: "Password",
    email: "Email",
    alertSuccessLogin: "Login successful!",
    alertSuccessRegister: "Registration successful!",
    alertServerError: "Server error, please try again",
    alertInvalidCredentials: "Invalid credentials!",
    alertUsernameExists: "Username already exists!",
    alertEmailExists: "This email address is already used by another user!",
    alertSuccessPasswordChange: "Password change was successful!",
    alertSuccessEmailChange: "Email change was successful!",
    alertInvalidPassword: "Wrong password!",
    alertRepeatPasswordWrong: "New passwords don't match!",
    alertTokenExpired: "Your session has expired, please login again.",
    noSubscription: "You don't have a subscription to VIP!",
    loading: "Loading...",
    profile: "Profile",
    traffic: "Traffic",
    subscription: "Subscription",
    subscriptionStatus: "Subscription Status",
    renewSubscription: "Renew Subscription",
    subscriptionValidUnitl: "Your VIP subscription is valid until: ",
    renewalDuration: "Select Renewal Duration: ",
    selectDuration: "-- Select Duration --",
    sevenDays: "7 days",
    thirtyDays: "30 days",
    renew: "Renew",
    saveChanges: "Save Changes",
    changePassword: "Change Password",
    changeEmail: "Change Email",
    oldPassword: "Current Password",
    newPassword: "New Password",
    repeatNewPassword: "Confirm New Password",
    newEmail: "New Email",
    odds: "Odds",
    date: "Date: ",
    time: "Time: ",
    prediction: "Prediction",
    match: "Match",
    won: "Won",
    result: "Result",
    submit: "Submit",
    newResult: "New Result",
    newArticle: "New Article",
    articleTitle: "Title",
    articleDetails: "Details",
    articleImage: "Photo: ",
    price: "Price",
    successPayment: "Payment was successfull, your subscription has renewed!",
    failedPayment: "Failed to process payment, please try again.",
    units: "Units",
    talkToBot: "Join the Telegram VIP Channel from our bot",
    joinFreeChannel: "Join our Telegram Free Channel",
    checkStatus: "Your subscription has renewed! You can join the Telegram VIP channel via the Subscription Status menu.",
    mrArber: "Mr. Arber",
    vretanos: "Vretanos",
    nole: "Nole",
    welcome: "Welcome to Art of Betting",
    welcomeText1: "At Art of Betting, we believe that betting is more than just a game of chance – it's strategy, knowledge, and analysis. Our mission is to provide you with reliable predictions, match analyses, and smart strategies, so you can make informed decisions.",
    welcomeText2: "Our team consists of experienced tipsters, analysts, and betting enthusiasts who study the markets, odds, and trends daily to offer you the most accurate information.",
    whatYouWillFind: "What You Will Find at Art of Betting",
    analysisPredictions: "Analyses & Predictions – Studied suggestions for top competitions and less popular leagues.",
    bettingStrategies: "Betting Strategies – Guides and techniques to help you improve your game.",
    bettingNews: "Betting News & Trends – Be the first to know about developments that affect the odds.",
    bankrollManagement: "Bankroll Management – Tips for proper bankroll management to bet responsibly.",
    ourGoal: "Our Goal",
    ourGoalText1: "Our goal is to turn betting into an art, giving you the tools you need to play with knowledge and confidence.",
    ourGoalText2: "Join our community and discover the Art of Betting!",
    whoIsMrArber: "Who is Mr. Arber",
    mrArberText1: "I am Mr. Arber, and betting is not just a passion – it's a way of life. Since its birth, close to the millennium, I have been in the game, watching its evolution, trends, and strategies that make it more than just a game of chance.",
    mrArberText2: "With years of experience, analysis, and market study, I have gained the knowledge needed to stand out in the field. I don't believe in random choices, but in information, strategy, and proper risk management.",
    mrArberText3: "My goal is to share this knowledge, help those who want to see betting more professionally, and deliver the true 'art of betting' through Art of Betting.",
    mrArberText4: "If you want to bet with knowledge and not luck, you are in the right place.",
    whoIsVretanos: "Who is Vretanos",
    vretanosText1: "Vretanos is the person who knows English football better than anyone. From the big Premier League competitions to the lower leagues, he knows everything: the teams, the tactics, the news, and the details that make the difference in betting.",
    vretanosText2: "He tirelessly studies the Old Continent, analyzing statistics, news, and match conditions to provide the most reliable assessments. He doesn't rely solely on numbers but also on a deep understanding of each team's dynamics, coaches, and players.",
    vretanosText3: "If you're looking for expertise in English football, Vretanos is the specialist who can guide you through the complexity of the markets and help you see betting from a different perspective.",
    whoIsNole: "Who is Nole",
    noleText1: "Nole is not just a tennis enthusiast – he is the ultimate expert. He has devoured books on statistics, analyzing every aspect of the sport, from player trends to the details that make the difference on every surface.",
    noleText2: "Numbers are not enough for him – where others see just a match, he observes every move, every reaction, every strategy, even from the court itself when he has the opportunity.",
    noleText3: "If you want predictions based on statistics, strategy, and the real picture of the game, Nole is your guy. With in-depth analyses and deep knowledge of the sport, he guides you to understand tennis beyond the obvious.",
    totalYear: "Season Total",
    totalMonth: "Monthly Total",
    totalWon: "Won",
    totalLost: "Lost",
    totalUnits: "Bets",
    totalReturns: "Returns",
    profitTotal: "Profit (ROI)",
    profitPercent: "Profit (ROI) %",
    results: "Results",
    noResults: "No results yet.",
    noArticles: "No articles yet.",
    readArticle: "Read the article",
  },
  gr: {
    title: "ART OF BETTING",
    slogan: "Η Τέχνη του Έξυπνου Στοιχηματισμού",
    home: "Αρχική",
    aboutUs: "Σχετικά με εμάς",
    freeBets: "FREE BETS",
    freeBetsDesc: "Δείτε τις δωρεάν προβλέψεις μας",
    freeBetsToday: "Free Bets",
    pregame: "Pregame",
    live: "Live",
    vip: "VIP",
    vipDesc: "Γίνετε μέλος της ομάδας που κερδίζει",
    vipBetsToday: "VIP Bets",
    statistics: "ΣΤΑΤΙΣΤΙΚΑ",
    statisticsDesc: "Δείτε τα στατιστικά των tipsters μας",
    statisticsToday: "Στατιστικά",
    articles: "ΑΡΘΡΑ",
    articlesDesc: "Διάβασε τα άρθρα των tipster μας!",
    articlesToday: "Άρθρα",
    algorithm: "ΑΛΓΟΡΙΘΜΟΣ",
    algorithmDesc: "Προβλέψεις από τον έξυπνο αλγόριθμό μας",
    poker: "ΠΟΚΕΡ",
    pokerDesc: "Τακτικές πόκερ που θα σας κάνουν πρωταθλητή",
    learnMore: "Μπείτε και κερδίστε!",
    learnMoreStats: "Δείτε τι λένε τα νούμερα!",
    learnMoreArticles: "Μελέτησε τα!",
    inprogress: "Έρχεται σύντομα!",
    switchTo: "English",
    login: "Σύνδεση",
    logout: "Αποσύνδεση",
    register: "Εγγραφή",
    username: "Όνομα Χρήστη",
    usernameOrEmail: "Όνομα Χρήστη ή Email",
    password: "Κωδικός",
    email: "Email",
    alertSuccessLogin: "Η σύνδεση ήταν επιτυχής!",
    alertSuccessRegister: "Η εγγραφή ήταν επιτυχής!",
    alertServerError: "Προέκυψε σφάλμα, παρακαλώ προσπαθήστε ξανά.",
    alertInvalidCredentials: "Λάθος στοιχεία σύνδεσης!",
    alertUsernameExists: "Το όνομα χρήστη υπάρχει ήδη!",
    alertEmailExists: "Αυτή η διεύθυνση email χρησιμοποιείται ήδη!",
    alertSuccessPasswordChange: "Ο κωδικός σας άλλαξε επιτυχώς!",
    alertSuccessEmailChange: "Το email σας άλλαξε επιτυχώς!",
    alertInvalidPassword: "Λάθος κωδικός!",
    alertRepeatPasswordWrong: "Οι νέοι κωδικοί δε ταιριάζουν!",
    alertTokenExpired: "Η συνεδρία σας έληξε, παρακαλώ συνδεθείτε ξανά.",
    noSubscription: "Δεν έχετε συνδρομή VIP!",
    loading: "Φόρτωση...",
    profile: "Προφίλ",
    traffic: "Επισκεψιμότητα",
    subscription: "Συνδρομή",
    subscriptionStatus: "Κατάσταση Συνδρομής",
    renewSubscription: "Ανανέωση Συνδρομής",
    subscriptionValidUnitl: "Η VIP συνδρομή σας ισχύει έως: ",
    renewalDuration: "Επιλέξτε διάρκεια συνδρομής: ",
    selectDuration: "-- Επιλέξτε διάρκεια --",
    sevenDays: "7 ημέρες",
    thirtyDays: "30 ημέρες",
    renew: "Ανανέωση",
    saveChanges: "Αποθήκευση Αλλαγών",
    changePassword: "Αλλαγή Κωδικού",
    changeEmail: "Αλλαγή Email",
    oldPassword: "Τρέχων Κωδικός",
    newPassword: "Νέος Κωδικός",
    repeatNewPassword: "Επιβεβαίωση Νέου Κωδικού",
    newEmail: "Νέο Email",
    odds: "Απόδοση",
    date: "Ημερομηνία: ",
    time: "Ώρα: ",
    prediction: "Πρόβλεψη",
    match: "Αγώνας",
    won: "Κερδισμένο",
    result: "Αποτέλεσμα",
    submit: "Υποβολή",
    newResult: "Νέο Αποτέλεσμα",
    newArticle: "Νέο Άρθρο",
    articleTitle: "Τίτλος",
    articleDetails: "Λεπτομέρειες",
    articleImage: "Φωτογραφία: ",
    price: "Τιμή",
    successPayment: "Επιτυχής πληρωμή, η συνδρομή σας ανανεώθηκε!",
    failedPayment: "Ανεπιτυχής πληρωμή, παρακαλώ προσπαθήστε ξανά.",
    units: "Units",
    talkToBot: "Μπες στο Telegram VIP channel μέσω του bot μας",
    joinFreeChannel: "Μπες στο Telegram Free Channel",
    checkStatus: "Η συνδρομή σας ανανεώθηκε! Μπορείτε να μπείτε στο Telegram VIP channel μέσω του μενού Κατάσταση Συνδρομής.",
    mrArber: "Mr. Arber",
    vretanos: "Vretanos",
    nole: "Nole",
    welcome: "Καλώς ήρθατε στο Art of Betting",
    welcomeText1: "Στο Art of Betting, πιστεύουμε ότι το στοίχημα είναι κάτι περισσότερο από ένα απλό παιχνίδι τύχης – είναι στρατηγική, γνώση και ανάλυση. Η αποστολή μας είναι να σας παρέχουμε αξιόπιστες προβλέψεις, αναλύσεις αγώνων και έξυπνες στρατηγικές, ώστε να παίρνετε τεκμηριωμένες αποφάσεις.",
    welcomeText2: "Η ομάδα μας αποτελείται από έμπειρους tipsters, αναλυτές και λάτρεις του στοιχήματος που μελετούν καθημερινά τις αγορές, τις αποδόσεις και τις τάσεις, για να σας προσφέρουν τις πιο ποιοτικές πληροφορίες.",
    whatYouWillFind: "Τι θα βρείτε στο Art of Betting",
    analysisPredictions: "Αναλύσεις & Προβλέψεις – Μελετημένες προτάσεις για κορυφαίες διοργανώσεις και λιγότερο δημοφιλή πρωταθλήματα.",
    bettingStrategies: "Στρατηγικές Στοιχήματος – Οδηγοί και τεχνικές που θα σας βοηθήσουν να βελτιώσετε το παιχνίδι σας.",
    bettingNews: "Στοιχηματικές Ειδήσεις & Τάσεις – Ενημερωθείτε πρώτοι για τις εξελίξεις που επηρεάζουν τις αποδόσεις.",
    bankrollManagement: "Διαχείριση Κεφαλαίου – Συμβουλές για σωστό bankroll management, ώστε να στοιχηματίζετε υπεύθυνα.",
    ourGoal: "Ο στόχος μας",
    ourGoalText1: "Στόχος μας είναι να μετατρέψουμε το στοίχημα σε τέχνη, δίνοντάς σας τα εργαλεία που χρειάζεστε για να παίξετε με γνώση και αυτοπεποίθηση.",
    ourGoalText2: "Γίνετε μέλος της κοινότητάς μας και ανακαλύψτε το Art of Betting!",
    whoIsMrArber: "Ποιος είναι ο Mr. Arber",
    mrArberText1: "Είμαι ο Mr. Arber, και το στοίχημα δεν είναι απλώς ένα πάθος – είναι τρόπος ζωής. Από τη γέννησή του, κοντά στο millennium, είμαι μέσα στο παιχνίδι, παρακολουθώντας την εξέλιξή του, τις τάσεις του και τις στρατηγικές που το κάνουν κάτι περισσότερο από ένα παιχνίδι τύχης.",
    mrArberText2: "Με χρόνια εμπειρίας, ανάλυσης και μελέτης των αγορών, έχω αποκτήσει τη γνώση που χρειάζεται για να ξεχωρίζει κάποιος στο χώρο. Δεν πιστεύω στις τυχαίες επιλογές, αλλά στην πληροφορία, τη στρατηγική και τη σωστή διαχείριση του ρίσκου.",
    mrArberText3: "Στόχος μου είναι να μοιραστώ αυτή τη γνώση, να βοηθήσω όσους θέλουν να δουν το στοίχημα πιο επαγγελματικά και να δώσω την πραγματική 'τέχνη του στοιχήματος' μέσα από το Art of Betting.",
    mrArberText4: "Αν θέλετε να στοιχηματίζετε με γνώση και όχι με τύχη, βρίσκεστε στο σωστό μέρος.",
    whoIsVretanos: "Ποιος είναι ο Vretanos",
    vretanosText1: "Ο Vretanos είναι ο άνθρωπος που ξέρει το αγγλικό ποδόσφαιρο καλύτερα από τον καθένα. Από τις μεγάλες διοργανώσεις της Premier League μέχρι τις μικρές κατηγορίες, γνωρίζει τα πάντα: τις ομάδες, τις τακτικές, τις ειδήσεις και τις λεπτομέρειες που κάνουν τη διαφορά στο στοίχημα.",
    vretanosText2: "Μελετά ασταμάτητα τη Γηραιά Αλβιώνα, αναλύοντας στατιστικά, ειδήσεις και αγωνιστικές συνθήκες, ώστε να προσφέρει τις πιο αξιόπιστες εκτιμήσεις. Δεν βασίζεται μόνο σε αριθμούς, αλλά και στη βαθιά γνώση της δυναμικής κάθε ομάδας, των προπονητών και των παικτών.",
    vretanosText3: "Αν ψάχνετε εξειδίκευση στο αγγλικό ποδόσφαιρο, ο Vretanos είναι ο ειδικός που μπορεί να σας καθοδηγήσει μέσα από την πολυπλοκότητα των αγορών και να σας βοηθήσει να δείτε το στοίχημα με διαφορετική ματιά.",
    whoIsNole: "Ποιος είναι ο Nole",
    noleText1: "Ο Nole δεν είναι απλά ένας λάτρης του τένις – είναι ο απόλυτος ειδικός. Έχει καταπιεί βιβλία στατιστικής, αναλύοντας κάθε πτυχή του αθλήματος, από τις τάσεις των παικτών μέχρι τις λεπτομέρειες που κάνουν τη διαφορά σε κάθε επιφάνεια.",
    noleText2: "Δεν του αρκούν οι αριθμοί – εκεί που άλλοι βλέπουν απλά έναν αγώνα, αυτός παρατηρεί ζωντανά κάθε κίνηση, κάθε αντίδραση, κάθε στρατηγική, ακόμα και από τον ίδιο τον αγωνιστικό χώρο, όταν έχει την ευκαιρία.",
    noleText3: "Αν θέλετε προγνωστικά με βάση τη στατιστική, τη στρατηγική και την πραγματική εικόνα του αγώνα, ο Nole είναι ο άνθρωπός σας. Με ψαγμένες αναλύσεις και βαθιά γνώση του αθλήματος, σας καθοδηγεί για να κατανοήσετε το τένις πέρα από τα προφανή.",
    totalYear: "Συνολικά Σεζόν",
    totalMonth: "Συνολικά Μήνα",
    totalWon: "Κερδισμένα",
    totalLost: "Χαμένα",
    totalUnits: "Πονταρίσματα",
    totalReturns: "Επιστροφές",
    profitTotal: "Κέρδος (ROI)",
    profitPercent: "Κέρδος (ROI) %",
    results: "Αποτελέσματα",
    noResults: "Δεν υπάρχουν αποτελέσματα.",
    noArticles: "Δεν υπάρχουν άρθρα.",
    readArticle: "Διάβασε το άρθρο",
  },
};

// Provider Component
export function LanguageProvider({ children }) {
  // Ανάκτηση γλώσσας από localStorage ή default στα Αγγλικά
  const [language, setLanguage] = useState(() => localStorage.getItem("language") || "gr");

  // Αποθήκευση γλώσσας στο localStorage κατά την αλλαγή
  useEffect(() => {
    localStorage.setItem("language", language);
  }, [language]);

  const toggleLanguage = () => {
    setLanguage((prev) => (prev === "en" ? "gr" : "en"));
  };

  return (
    <LanguageContext.Provider value={{ language, toggleLanguage, translations: translations[language] }}>
      {children}
    </LanguageContext.Provider>
  );
}

// Hook για εύκολη χρήση του Context
export function useLanguage() {
  return useContext(LanguageContext);
}
